<template>
    <div class="sidebar__section sticky-hint" v-if="hintContent">
        <el-collapse class="sticky-hint__inner" v-model="collapseOpen">
            <el-collapse-item class="sticky-hint__accordion" :name="collapseItemName">
                <div class="sticky-hint__title copy-light-small ui-center-vertically" slot="title" @click="collapseClickHandler">
                    <icon class="sticky-hint__title__icon" :size="16">
                        <IconCircleInfo />
                    </icon>
                    {{ hintContent.title }}
                    <icon class="sticky-hint__title__arrow" :size="20">
                        <IconChevronDown />
                    </icon>
                </div>   
                <div class="sticky-hint__text copy-light-small">
                    {{ hintContent.text }}
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import { setPermanentData, getPermanentData } from '@/utils/browser-storage';
import { mapGetters } from 'vuex';
import Icon from '@/components/Icon.vue'
import IconChevronDown from '@/components/icons/IconChevronDown.vue'
import IconCircleInfo from '@/components/icons/IconCircleInfo.vue'

export default {
    components: {
        Icon,
        IconChevronDown,
        IconCircleInfo
    },
    props: {
        activeDetailType: {
            type: String,
            default: 'route'
        },
    },
    data() {
        return {
            collapseOpen: [],
            collapseItemName: 'main',
            content: {
                route: {
                    title: 'Alle Angaben ohne Gewähr',
                    text: 'Die Route ist eine Planungshilfe und wurde auf Basis derzeit bekannter Verkehrsbehinderungen erstellt. Die tatsächliche Fahrtdauer kann aufgrund von Verkehrsereignissen, Wetter, etc. abweichen. Wir empfehlen, Datum und Uhrzeit entsprechend Ihrer geplanten Abfahrt anzupassen und kurz vor Fahrtbeginn die Route nochmals zu prüfen.',
                    name: 'routeDetailHint',
                }
            }
        }
    },
    computed: {
        ...mapGetters(['mobile']),
        hintContent() {
            return this.content[this.activeDetailType] || false
        }
    },
    mounted() {
        this.checkIfAlreadyClosed()
    },
    methods: {
        checkIfAlreadyClosed() {
            const storedData = getPermanentData(this.hintContent.name)
            if(!storedData) {
                this.collapseOpen.push(this.collapseItemName)
            }
        },
        collapseClickHandler() {
            const isClosing = this.collapseOpen.length > 0
            const initialElHeight = this.$el.getBoundingClientRect().height
            if(this.mobile) {
                setTimeout(() => {
                    const currentElHeight = this.$el.getBoundingClientRect().height
                    eventBus.$emit('scrollPOIDetailToBottom', { offset: isClosing ? initialElHeight - currentElHeight : 0 });
                }, 400);
            } else {
                eventBus.$emit('triggerPOIDetailScrollbar');
            }
            this.saveAlreadyClosed()
        },
        saveAlreadyClosed() {
            setPermanentData(this.hintContent.name, true);
        }
    },
}
</script>

<style lang="scss">
.sticky-hint {
    position: sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    margin-top: auto;
    z-index: 10;
    background: white;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);

    @include mq($until: tablet) {
        position: static;
        box-shadow: none;
        border-top: 1px solid $color-black-005-solid;
    }

    &__accordion {
        margin: 0 !important;
    }

    &__title {
        width: 100%;
        gap: 8px;
        justify-content: center;
        padding: 8px 0;
        transition: 0.4s $ease-out-quart;

        .no-touch &:hover {
            color: $color-black;
        }

        &__arrow {
            transform: rotate(180deg);
            transition: 0.4s $ease-out-quart;

            .is-active & {
                transform: none;
            }
        }
    }

    &__text {
        padding: 8px 0 16px;
    }
}
</style>